/**
 * HotelReviews component.
 */
define([
    'jQuery',
    'library/fcse-compatibility/object',
    'library/fcse-component/optionsMixin',
    'library/fcse-events/eventDispatcher',
    'clientComponents/inlinemodal/inlineModal',
    'library/fcse-content/tabs',
    'library/fcse-request/multiRequestHandler',
    'library/fcse-dropdown/dropdown',
    'library/fcse-content/forwardPaging',
    'library/fcse-visibilitycontrol/contentExpander',
    'clientComponents/lazyimage/lazyImage'
],
    function($, Object, OptionsMixin, EventDispatcher, InlineModal, Tabs, MultiRequestHandler, Dropdown, ForwardPaging,
        ContentExpander, LazyImage) {

        var HotelReviews = function(element, scope, options) {
            EventDispatcher.apply(this, arguments);

            // Set default options
            var defaultOptions = {
                'tabs': '.tabnavigation',
                'tabsContainer': '.tabcontainer',
                'imageModals': '[data-fcse-role=inline-modal-image]',
                'sortElements': {
                    'picture': '[data-fcse-role="media--sort"][data-media-type="picture"]',
                    'video': '[data-fcse-role="media--sort"][data-media-type="video"]'
                },
                'reviewsSourceRoute': 'allt_frontend.hotel.detail.reviews',
                'mediaSourceRoutePrefix': 'allt_frontend.hotel.detail.reviews.',
                'mediaPaginationContainer': '[data-fcse-role="media--pagination"]',
                'mediaSortContainer': '[data-fcse-role="media--sort"]',
                'forwardPagination': {
                    'container': '[data-fcse-role="forward-pagination-content"]',
                    'button': '[data-fcse-role="forward-pagination"]'
                }
            };

            // Store element
            this.element = $(element);
            this.reviewsTab = $('#reviews');
            this.reviewsRequestHandler = new MultiRequestHandler();
            this.mediaRequestHandler = new MultiRequestHandler();

            // Save local variables
            this.scope = scope;
            this.reviewsInitialRouteParams = this.element.data("initial-reviews-route-params");
            this.reviewsQueryCondititon = this.element.data("initial-reviews-query-condition");

            this.mediaInitialRouteParams = this.element.data("initial-media-route-params");
            this.mediaQueryCondititon = this.element.data("initial-media-query-condition");

            // Set additional params to local scope
            this.initialAdditionalParams = $(element).data("initial-additional-params");
            this.scope.setMultipleParams(this.initialAdditionalParams);

            this.addOptions(defaultOptions, options);

            this._init();
            this._initSuccessLoadHandlers();
            this._bindReviewsPagination();

            new Dropdown(this.getOptions().sortElements.picture, {});
            new Dropdown(this.getOptions().sortElements.video, {});
        };

        HotelReviews.prototype = $.extend(Object.create(EventDispatcher.prototype), Object.create(OptionsMixin),{
            /**
             * Initialize Offerlist
             *
             * @private
             */
            _init: function() {
                new Tabs($(this.getOptions()['tabs'], this.element), $(this.getOptions()['tabsContainer'], this.element));
                new InlineModal($(this.getOptions()['imageModals'], this.element), {
                    autoHide: false,
                    triggerEventName: 'click',
                    hideOnLeave: false
                });
                this._bindMediaPagination();
                this._bindMediaSort();
                this._bindReviewsToggle();
            },

            _initSuccessLoadHandlers: function () {
                var that = this;
                this.reviewsRequestHandler.on('success', function(data) {
                    $(that.getOptions().forwardPagination.container, this.reviewsTab).append(data.html);
                    $(that.getOptions().forwardPagination.button).removeAttr('disabled');
                    if (!data.html)
                        $(that.getOptions().forwardPagination.button).hide();
                    that._bindReviewsToggle();
                });
                this.reviewsRequestHandler.on('error', function(data) {
                });
                that.mediaRequestHandler.on('success', function(data) {
                    $('[data-fcse-role="media--'+data.meta.mediaType+'-container"]', that.element).removeClass('is-loading').html(data.html);
                    that._init();
                    new Dropdown(that.getOptions().sortElements[data.meta.mediaType], {});
                    LazyImage.loadImages(that.element);
                });
            },

            _bindReviewsToggle: function() {
                new ContentExpander($('[data-fcse-role="expandable-content"]', this.element).not('.expandable-content-binded'), {
                    'collapsedClass': 'is-collapsed-review',
                    'expandedClass': 'is-expanded-review'
                });
                $('[data-fcse-role="expandable-content"]', this.element).addClass('expandable-content-binded');
            },

            _bindReviewsPagination: function() {
                this.forwardPagination = new ForwardPaging($(this.getOptions().forwardPagination.button, this.element), {});
                this.forwardPagination.setValue({currentIndex: 1});
                this.forwardPagination.on('change', $.proxy(this._onReviewsForwardPaginate, this));
            },

            _onReviewsForwardPaginate: function() {
                $(this.getOptions().forwardPagination.button).attr('disabled', 'disabled');
                this.reviewsQueryCondititon.page = this.forwardPagination.getValue().currentIndex;
                this._loadData(this.getOptions().reviewsSourceRoute, this.reviewsInitialRouteParams, this.reviewsQueryCondititon);
            },

            _bindMediaPagination: function() {
                var that = this;
                $(that.getOptions().mediaPaginationContainer).each(function () {
                    $('[data-page]', this).off('click').on('click',
                        $.proxy(that._onMediaPaginationClick, that, $(this).data('media-type')));
                });
            },

            _onMediaPaginationClick: function(mediaType, event) {
                var data = this.mediaQueryCondititon;
                data.page = $(event.currentTarget).data('page');
                $('[data-fcse-role="media--'+mediaType+'-container"]', this.element).addClass('is-loading')

                this._loadMediaData(this.getOptions().mediaSourceRoutePrefix+mediaType, this.mediaInitialRouteParams, data);
            },

            _bindMediaSort: function() {
                var that = this;
                $(that.getOptions().mediaSortContainer).each(function () {
                    $('.dropdown--optionlabel', this).off('click').on('click',
                        $.proxy(that._onMediaSortChange, that, $(this).data('media-type')));
                });
            },

            _onMediaSortChange: function(mediaType, event) {
                if ($(event.currentTarget).hasClass('is-selected'))
                    return true;

                this.mediaQueryCondititon.page = 1;
                this.mediaQueryCondititon.sort = $(event.currentTarget).data('value');
                this.mediaQueryCondititon.sortOrder = $(event.currentTarget).data('sort-order');

                $('[data-fcse-role="media--'+mediaType+'-container"]', this.element).addClass('is-loading')

                this._loadMediaData(this.getOptions().mediaSourceRoutePrefix+mediaType, this.mediaInitialRouteParams, this.mediaQueryCondititon);
                return true;
            },

            _loadData: function(route, routeParams, query) {
                this.reviewsRequestHandler.cancel(route);
                this.reviewsRequestHandler.send(route, query, routeParams);
            },

            _loadMediaData: function(route, routeParams, query) {
                this.mediaRequestHandler.cancel(route);
                this.mediaRequestHandler.send(route, query, routeParams);
            }
        });

        return HotelReviews;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/hotelReviews/hotelreviews.js